"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSellYourElectricity = function IconSellYourElectricity(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M24 7.12a7.88 7.88 0 0 1 7.839 7.081 13 13 0 0 0 1.685-.687l.059-.03-.352-.844L36 13l-1.69 2.22-.34-.812q-1.014.5-2.096.83A7.88 7.88 0 0 1 24 22.88a7.88 7.88 0 0 1-7.87-7.456 40.7 40.7 0 0 1-9.088-1.966l16.14 16.14-.21 7.402H17v8h-2V35h6.028l.13-4.597L3.046 12.29q.503-.9 1.08-1.748l1.224 1.223a39.7 39.7 0 0 0 10.793 2.655A7.88 7.88 0 0 1 24 7.12M41.889 8q.58.647 1.111 1.335V16h3.635q.059.167.115.335V18H43v20.665a24 24 0 0 1-2 2.276V18h-6v-2h6v-6h-6V8zM9 39H7v-9H2v-2h7zM24 9.12a5.88 5.88 0 1 0 0 11.76 5.88 5.88 0 0 0 0-11.76m.5 5.38L26 14l-3 5 .5-3.5-1.5.5 3-5z"
  })));
};

export { IconSellYourElectricity, IconSellYourElectricity as default };
